// extracted by mini-css-extract-plugin
module.exports = {"header":"Events_header__3UgfT","filterDropbox":"Events_filterDropbox__3tolU"};